const newTabParamsStore = {
  state: {
    params: { patiSeq: '', surveyCycleList: [] },
    params2: {},
    searchParams: {},
    additionalSearchParams: {} // 추가: UI 전용 검색 조건 저장
  },
  getters: {
    getParams(state) {
      return state.params;
    },
    getParams2(state) {
      return state.params2;
    },
    getSearchParams: (state) => (pageKey) => {
      return state.searchParams[pageKey] || {};
    },
    getAdditionalSearchParams: (state) => (pageKey) => {
      return state.additionalSearchParams[pageKey] || {};
    }
  },
  mutations: {
    setParams(state, param) {
      state.params = param;
    },
    setParams2(state, param) {
      state.params2 = param;
    },
    setSearchParams(state, payload) {
      state.searchParams[payload.pageKey] = payload.param;
      console.log("searchParams:", state.searchParams);
    },
    setAdditionalSearchParams(state, payload) {
      state.additionalSearchParams[payload.pageKey] = payload.param;
      console.log("additionalSearchParams:", state.additionalSearchParams);
    },
    resetSearchParams(state) {
      state.searchParams = {};
      state.additionalSearchParams = {};
    }
  },
  actions: {}
};

export default newTabParamsStore;
